import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer';
import { InviteUserForm } from './InviteUserForm';
import { ManageUsersContent } from '@/content/ManageUsersContent';
import { Link } from '@tanstack/react-router';
import { UploadSimpleIcon } from '@phosphor-icons/react';

export interface InviteUserDrawerProps {
  /** Controls whether the drawer is open */
  open: boolean;
  /** Callback when the drawer open state changes */
  onOpenChange: (open: boolean) => void;
}

/**
 * Drawer component that displays the invite user form
 */
export function InviteUserDrawer({
  open,
  onOpenChange,
}: InviteUserDrawerProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <div className="mx-auto w-full max-w-sm">
          <DrawerHeader>
            <div className="flex items-center justify-between mb-2">
              <DrawerTitle className="text-[24px]">
                {ManageUsersContent.invite.title}
              </DrawerTitle>
              <Link
                to="/admin/manage-users/import"
                onClick={() => onOpenChange(false)}
                className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-sky-300 hover:text-sky-50 transition-colors"
              >
                <UploadSimpleIcon size={20} weight="bold" />
                {ManageUsersContent.bulkImport.addMultiple}
              </Link>
            </div>
            <DrawerDescription className="text-body text-slate-300">
              {ManageUsersContent.invite.description}
            </DrawerDescription>
          </DrawerHeader>
          <div className="pb-4">
            <InviteUserForm onSuccess={() => onOpenChange(false)} />
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}

